<template>
  <div class="animated fadeIn">
    <b-row v-if="survey">
      <b-col md="6">        
          <b-card>
            <div slot="header">
              Manage Survey
            </div>
            <b-card-body>
              <div v-if="surveyMode==='step-survey'">
                <Survey :survey="survey"></Survey>
              </div>
              <div v-if="surveyMode==='step-question'">
                <Question :survey="survey" :question="question"></Question>
              </div>
              <div v-if="surveyMode==='step-option'">
                <OptionItem :survey="survey" :question="question" :option="option"></OptionItem>
              </div>
            </b-card-body>
          </b-card>
      </b-col>
      <b-col md="6">
        <b-card>
          <div slot="header">
            Preview
          </div>
          <b-card-body>
            <div class="mb-4">
              <h3>
                <a href="#" @click.prevent="showSurveyEdit(survey)">{{survey.name}}</a> 
                <span class="addIcon ml-2"><a href="#" @click.prevent="showQuestionAdd()">
                  <i class="fa fa-plus-circle"></i>
                </a></span>
              </h3>
            </div>
            <div class="mb-4" v-for="question in survey.questions" :key="question._id">
              <h4>
                <span class="deleteIcon"><a href="#" @click.prevent="deleteQuestion(question._id)">
                  <i class="fa fa-minus-circle mr-2"></i>
                </a></span> 
                <a href="#" @click.prevent="showQuestionEdit(question)">{{question.name}}</a> 
                <span class="addIcon" v-if="hasOptions(question)"><a href="#" @click.prevent="showOptionAdd(question)">
                  <i class="fa fa-plus-circle ml-2"></i>
                </a></span>
              </h4>
              <div class="ml-4" v-for="option in question.options" :key="option._id">
                <div>
                  <span class="deleteIcon"><a href="#" @click.prevent="deleteOption(option._id)">
                    <i class="fa fa-minus-circle mr-2"></i></a></span> 
                    <input type="radio" disabled v-if="question.type==='single-choice'">
                    <input type="checkbox" disabled v-if="question.type==='multiple-choice'"> 
                    <a href="#" @click.prevent="showOptionEdit(option)">{{option.name}}</a>
                </div>
              </div>
            </div>
          </b-card-body>
        </b-card>
        <b-card>
          <div slot="header">
            Stats
          </div>
          <b-card-body>
            <div class="mb-4" v-if="statCharts.length > 0" v-for="statChart in statCharts" :key="statChart.questionId">
              <bar-chart :chart-data="statChart" :options="chartOptions" :height="200"></bar-chart>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios'
import Survey from './Survey'
import Question from './Question'
import OptionItem from './OptionItem'
import BarChart from './../charts/BarChart'
import { getStyle, hexToRgba } from '@coreui/coreui/dist/js/coreui-utilities'

export default {
  name: 'managesurvey',
  components: {
    Survey,
    Question,
    OptionItem,
    BarChart
  },
  data () {
    return {
      statCharts: [],
      myModal: false
    }
  },
  computed: {
    id: function () {
      return this.$route.params.id
    },
    surveyMode () {
      return this.$store.getters.surveyMode;
    },
    survey () {
      return this.$store.getters.survey;
    },
    question () {
      return this.$store.getters.question;
    },
    option () {
      return this.$store.getters.option;
    },
    surveyStats () {
      return this.$store.getters.surveyStats;
    },
    chartOptions () {
      let scope = this;
      return {
        scales: {
          xAxes: [{
            ticks: {
              min: 0,
              callback: function(value, index, values) {
                return Math.floor(value);
              }
            }
          }]
        }
      }
    },
    currentUser () {
      return this.$store.getters.currentUser;
    }
  },
  methods: {
    deleteQuestion (id) {
      this.$store.dispatch('deleteQuestion', id).then(result => {
        this.$store.dispatch('getSurvey', this.id);
      }, error => {
        console.log(error);
      })
    },
    deleteOption (id) {
      this.$store.dispatch('deleteOption', id).then(result => {
        this.$store.dispatch('getSurvey', this.id);
      }, error => {
        console.log(error);
      })
    },
    showOptionAdd (question) {
      this.$store.commit('updateOption', {});
      this.$store.commit('updateQuestion', question);
      this.$store.commit('updateSurveyMode', 'step-option');
    },
    showQuestionAdd () {
      this.$store.commit('updateQuestion', {});
      this.$store.commit('updateQuestionIsEdit', false);
      this.$store.commit('updateSurveyMode', 'step-question');
    },
    hasOptions (question) {
      if(question.type === 'text') {
        return false;
      }
      return true;
    },
    showSurveyEdit (survey) {
      this.$store.commit('updateSurvey', survey);
      this.$store.commit('updateSurveyIsEdit', true);
      this.$store.commit('updateSurveyMode', 'step-survey');
    },
    showQuestionEdit (question) {
      this.$store.commit('updateQuestion', question);
      this.$store.commit('updateQuestionIsEdit', true);
      this.$store.commit('updateSurveyMode', 'step-question');
    },
    showOptionEdit (option) {
      this.$store.commit('updateOption', option);
      this.$store.commit('updateOptionIsEdit', true);
      this.$store.commit('updateSurveyMode', 'step-option');
    }
  },
  created () {
    let scope = this;
    scope.$store.commit('updateSurveyMode', 'step-survey');
    if(scope.id) {
      scope.$store.commit('updateSurveyIsEdit', true);
      scope.$store.dispatch('getSurvey', scope.id);
      scope.$store.dispatch('getSurveyStats', {
        id: scope.id,
        companyId: scope.currentUser.company
      }).then((result => {
        scope.surveyStats[0].questions.forEach(surveyStat => {          
          scope.statCharts.push({
            labels: surveyStat.options.map(option => option.optionName),
            datasets: [
              {
                label: surveyStat.questionName,
                backgroundColor: hexToRgba('#592b8b', 10),
                borderColor: '#592b8b',
                pointHoverBackgroundColor: '#fff',
                borderWidth: 1,
                data: surveyStat.options.map(option => option.optionCount)
              }
            ]
          })
        });
      }), error => {
        console.log(error);
      })
    } else {
      scope.$store.commit('updateSurvey', {region: null, branch: null, device: null});
      scope.$store.commit('updateSurveyIsEdit', false);
    }
  }
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
